import React from "react";
import "./FilterToolbar.css";

const FilterToolbar = ({
  filters,
  onFilterChange,
  onReset,
  totalCount,
  filteredCount,
  childrenCount,
  adultsCount,
  occupiedCourses = 0,
  possibleCourses = 0,
}) => {
  // Check if any filter is active (not "all")
  const hasActiveFilters = Object.values(filters).some(
    (value) => value !== "all"
  );

  return (
    <div className="filter-toolbar">
      <div className="filter-header">
        <h3>🔍 Filter</h3>
        <button
          className={`reset-filters-btn ${hasActiveFilters ? "active" : ""}`}
          onClick={onReset}
          title="Alle Filter zurücksetzen"
        >
          ↺ Zurücksetzen
        </button>
      </div>

      <div className="filter-grid">
        {/* Assignment Status Filter */}
        <div className="filter-item">
          <label htmlFor="assignmentStatus">Status</label>
          <select
            id="assignmentStatus"
            value={filters.assignmentStatus}
            onChange={(e) => onFilterChange("assignmentStatus", e.target.value)}
          >
            <option value="all">Alle</option>
            <option value="assigned">Zugewiesen</option>
            <option value="unassigned">Nicht zugewiesen</option>
          </select>
        </div>

        {/* Adult/Children Filter */}
        <div className="filter-item">
          <label htmlFor="ageGroup">Altersgruppe</label>
          <select
            id="ageGroup"
            value={filters.ageGroup}
            onChange={(e) => onFilterChange("ageGroup", e.target.value)}
          >
            <option value="all">Alle</option>
            <option value="adult">Erwachsene</option>
            <option value="children">Kinder</option>
          </select>
        </div>

        {/* Team Player Filter (only for children) */}
        {filters.ageGroup !== "adult" && (
          <div className="filter-item">
            <label htmlFor="teamPlayer">Teamspieler</label>
            <select
              id="teamPlayer"
              value={filters.teamPlayer}
              onChange={(e) => onFilterChange("teamPlayer", e.target.value)}
            >
              <option value="all">Alle</option>
              <option value="yes">Ja</option>
              <option value="no">Nein</option>
            </select>
          </div>
        )}

        {/* Training Group Filter (only for children) */}
        {filters.ageGroup !== "adult" && (
          <div className="filter-item">
            <label htmlFor="trainigGroup">Trainingsgruppe</label>
            <select
              id="trainigGroup"
              value={filters.trainigGroup}
              onChange={(e) => onFilterChange("trainigGroup", e.target.value)}
            >
              <option value="all">Alle</option>
              <option value="Kinderland">🩷 Kinderland</option>
              <option value="Rot">🔴 Rot</option>
              <option value="Orange">🟠 Orange</option>
              <option value="Grün">🟢 Grün</option>
              <option value="Gelb Team">🟡 Gelb Team</option>
              <option value="Gelb Hobby">🟡 Gelb Hobby</option>
            </select>
          </div>
        )}

        {/* Skill Level Filter (only for adults) */}
        {filters.ageGroup !== "children" && (
          <div className="filter-item">
            <label htmlFor="skillLevel">Spielstärke</label>
            <select
              id="skillLevel"
              value={filters.skillLevel}
              onChange={(e) => onFilterChange("skillLevel", e.target.value)}
            >
              <option value="all">Alle</option>
              <option value="Anfänger">Anfänger</option>
              <option value="Anfänger mit Grundkenntnissen">
                Anfänger mit Grundkenntnissen
              </option>
              <option value="Fortgeschritten">Fortgeschritten</option>
              <option value="Erfahrene Spieler:innen / Mannschaftsspieler:innen">
                Erfahrene Spieler:innen / Mannschaftsspieler:innen
              </option>
              <option value="Leistungsspieler:innen / Turnierspieler:innen">
                Leistungsspieler:innen / Turnierspieler:innen
              </option>
            </select>
          </div>
        )}
      </div>

      <div className="filter-results">
        <span className="result-count">
          {filteredCount} von {totalCount} Schüler{totalCount !== 1 ? "n" : ""}
        </span>
        <span className="age-group-counts">
          <span className="count-item">👶 U18: {childrenCount}</span>
          <span className="count-separator">•</span>
          <span className="count-item">👨 Erwachsene: {adultsCount}</span>
          {possibleCourses > 0 && (
            <>
              <span className="count-separator">•</span>
              <span className="count-item">📅 {occupiedCourses} Kurse belegt von {possibleCourses} möglichen Kursen</span>
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default FilterToolbar;
